import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';

interface ReorderDataHooks {
  dataHookFrom: string;
  dataHookTo: string;
}

export interface SortableListBaseDriver extends BaseDriver {
  reorder: (dataHooks: ReorderDataHooks) => void;
  getItemPosition: (itemDetails: { dataHook: string }) => number;
}
